import {ContextMenu} from "./contextMenu";

export class FancytreeContextMenu<T> extends ContextMenu<T> {
	/**
	 * Renders the context menu definition.
	 * At this time it will be decided what elements are displayed and what elements are active.
	 * This can be called inside the renderNode call of a FancyTree definition to add the context menu html to the node span
	 */
	public render = (record: T) => {
		const contextMenu = this.renderDropdown(record);

		if (contextMenu !== "") {
			return $("<div>", {"style": "display:inline-block;"}).addClass("dropdown")
				.append(
					$("<a>", {"data-toggle": "dropdown", "aria-expanded": "false"})
						.addClass("dropdown-toggle")
						.append($("<i>").addClass("fa fa-bars"))
				)
				.append(contextMenu);
		} else {
			return "";
		}
	}

	/**
	 * Registers click listeners for the context menu on the specified FancyTree
	 */
	public registerOnFancytree(tree: Fancytree.Fancytree, allowRightClick: boolean = true) {
		tree.$container
			.on("click", "ul.dropdown-menu > li", (event) => {
				const element = $(event.currentTarget as HTMLElement);

				if (!element.hasClass("disabled")) {
					const span = element.closest("span.fancytree-node");
					const key = span.data("node-key") as string;
					const record = tree.getNodeByKey(key).data as T;
					const action = element.data("action") as string;

					this.triggerAction(action, record, span);
				}
			})
			.on("shown.bs.dropdown", "div.dropdown", (event) => {
				const element = $(event.target as HTMLElement);
				const menu = element.children("ul.dropdown-menu");
				const span = element.closest("span.fancytree-node");
				const key = span.data("node-key") as string;
				const record = tree.getNodeByKey(key).data as T;
				this.updateDynamicRecordActiveness(record, menu);

				const containerOffset = tree.$container.offset();
				const menuOffset = menu.offset();

				// Position inside the tree container
				const menuPos = menuOffset.top - containerOffset.top;
				// Bottom edge of the context menu
				const menuBottom = menuPos + menu.outerHeight();

				const containerHeight = tree.$container.outerHeight();

				if (menuBottom > containerHeight) {
					const offset = (containerHeight - menuBottom) + 13; // Add size of icon

					// Move the context menu a bit up if it would overflow the container element
					menu.css("left", "10px")
						.css("top", `${offset}px`);
				}
			})
			.on("hidden.bs.dropdown", "div.dropdown", (event) => {
				const menu = $(event.target as HTMLElement).children("ul.dropdown-menu");

				const top = menu.css("top");
				if (top) {
					menu.css("left", "")
						.css("top", "");
				}
			});

		if (allowRightClick) {
			// We create a menu container inside the the tree regardless of what node actually needs the context menu later.
			const containerID = "container_" + crypto.randomUUID();
			const rightClickMenuContainer = $("<div class='fancytree-context-menu-container'>");
			rightClickMenuContainer.attr("id", containerID);
			tree.$div.append(rightClickMenuContainer);

			tree.$div.on("contextmenu", "span.fancytree-title", (event) => {
				const node = $.ui.fancytree.getNode(event as unknown as Event);

				// On context event (right click) on node titles we add bootstrap data-toggle references to the span
				// since fancytree does not allow to modify spans directly when they are rendered. Since this event
				// handler gets called before the bootstrap one and we dont cancel the event by returning false then
				// by the time bootstrap processes the event the toggles are installed correctly.
				$(node.span)
					.attr("data-toggle", "context")
					.attr("data-target", "#" + containerID);
			});

			rightClickMenuContainer
				.on("show.bs.context", e => {
					if (!this._onOpenByRightClick()) {
						// Block the opening of the context menu
						e.preventDefault();
						return;
					}

					// Close other open context menus in the tree
					tree.$div.find(`a[aria-expanded="true"]`).each((i, ele) => {
						$(ele)
							.attr("aria-expanded", "false")
							.closest("div.dropdown")
							.removeClass("open");
					});

					// Render the context menu on the fly when its supposed to be shown inside the special menu container.
					// $element is a bootstrap-context addition absent from the jQuery event typings.
					const contextEvent = e as BootstrapContextEvent;
					const nodeElement = contextEvent.relatedTarget.$element;
					const node = $.ui.fancytree.getNode(nodeElement);
					const contextMenu = this.renderDropdown(node.data as T);

					if (contextMenu !== "") {
						this.updateDynamicRecordActiveness(node.data as T, contextMenu);
					}

					rightClickMenuContainer
						.empty()
						.append(contextMenu)
						.data("target-node-key", node.key);
				})
				.on("hidden.bs.context", e => {
					rightClickMenuContainer.empty();
				})
				.on("click", "ul.dropdown-menu > li", e => {
					const element = $(e.currentTarget as HTMLElement);

					if (!element.hasClass("disabled")) {
						// When a click on a menu entry inside the container happens we find he correct recording
						// trigger the action handler.
						const nodeKey = element.closest(".fancytree-context-menu-container").data("target-node-key") as string;
						const action = element.data("action") as string;
						const node = tree.getNodeByKey(nodeKey);

						this.triggerAction(action, node.data as T, $(node.span));
					}
				});
		}
	}
}
